


jQuery(".form-mailup").each(function (t, e) {
    e.addEventListener("wpcf7submit", function () {
      var cf7Form = jQuery(this);

      if (jQuery("input[name='privacy']", cf7Form).is(":checked")) {
        var groupId = cf7Form.attr("id").replace("mailup-", "");
        groupId = parseInt(groupId);

        var name = "";
        jQuery("input[name='nome']", cf7Form).length &&
          (name = jQuery("input[name='nome']", cf7Form).val());

        var surname = "";
        jQuery("input[name='cognome']", cf7Form).length &&
          (surname = jQuery("input[name='cognome']", cf7Form).val());

        var role = "";
        jQuery("select[name='ruolo']", cf7Form).length &&
          (role = jQuery("select[name='ruolo']", cf7Form).val());

        var company = "";
        jQuery("input[name='azienda']", cf7Form).length &&
          (company = jQuery("input[name='azienda']", cf7Form).val());
        var pageTitle = "";
        jQuery(document).find("title").text() &&
          (pageTitle = jQuery(document).find("title").text());

        var locationLink = "";
        location.href && (a = location.href);

        var email = "";
        jQuery("input[name='email']", cf7Form).length &&
          (email = jQuery("input[name='email']", cf7Form).val());

        var phone = "";
        jQuery("input[name='telefono']", cf7Form).length &&
          (phone = jQuery("input[name='telefono']", cf7Form).val());

        var city = "";
        jQuery("input[name='citta']", cf7Form).length &&
          (city = jQuery("input[name='citta']", cf7Form).val());
        if (groupId > 0 && email) {
           
          jQuery.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: "post",
            data: {
              action: "mailup_ortica",
              email: email,
              id_group: groupId,
              id_list: 5,
              data_title: jQuery(document).find("title").text(),
              data_link: location.href,
              fld_names:
                "campo1;campo2;campo3;campo4;campo14;campo15;campo6;campo7;campo10",
              fld_values:
                name +
                ";" +
                surname +
                ";" +
                role +
                ";" +
                company +
                ";" +
                pageTitle +
                ";" +
                locationLink +
                ";" +
                email +
                ";" +
                phone +
                ";" +
                city,
            },
            dataType: "json",
            success: function (t) {},
            complete: function () {},
            beforeSend: function () {},
          });
        }
      }
    });
  });